import { style } from '@vanilla-extract/css';

export const playerContainer = style(
  {
    height: '100%',
    position: 'relative',
    width: '100%',
  },
  'player-container',
);
